import { render, staticRenderFns } from "./ServiceVisitCustomTaskRow.vue?vue&type=template&id=57f779d4&"
import script from "./ServiceVisitCustomTaskRow.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitCustomTaskRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
